import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const LANGUAGE_LABELS = {
    ESC_POS: 'RECEIPT / ESC-POS MODE',
    TSPL: 'LABEL / TSPL MODE',
};

const PrinterModeConfirmDialog = ({
    visible,
    printerName,
    requiredLanguage,
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog
            header="Printer Mode Change Required"
            visible={visible}
            style={{ width: '30rem' }}
            modal
            closable={false}
            onHide={onCancel}
        >
            <div className="p-3">
                <p>
                    The printer <strong>{printerName}</strong> must be switched to:
                </p>

                <p className="text-center text-xl font-bold mt-3 mb-3">
                    {LANGUAGE_LABELS[requiredLanguage]}
                </p>

                <p>
                    Please manually change the printer mode before continuing.
                </p>

                <div className="flex justify-content-end gap-2 mt-4">
                    <Button
                        label="Cancel"
                        className="p-button-text"
                        onClick={onCancel}
                    />
                    <Button
                        label="I have switched the printer"
                        icon="pi pi-check"
                        onClick={onConfirm}
                        autoFocus
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default PrinterModeConfirmDialog;
